import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "./ui/button";

const AdminPagination = ({
  page,
  totalItems,
  pageSize = 10,
  onPageChange,
  itemLabel = "data",
}) => {
  const totalPages = Math.max(1, Math.ceil(totalItems / pageSize));
  const safePage = Math.min(Math.max(page, 1), totalPages);
  const start = totalItems === 0 ? 0 : (safePage - 1) * pageSize + 1;
  const end = Math.min(safePage * pageSize, totalItems);

  if (totalItems <= pageSize) {
    return (
      <div className="mt-4 text-sm text-stone-500">
        Menampilkan {totalItems} {itemLabel}.
      </div>
    );
  }

  return (
    <div className="mt-5 flex flex-col gap-3 rounded-2xl border border-stone-200 bg-white px-4 py-3 sm:flex-row sm:items-center sm:justify-between">
      <p className="text-sm text-stone-500">
        Menampilkan <span className="font-medium text-stone-800">{start}-{end}</span> dari{" "}
        <span className="font-medium text-stone-800">{totalItems}</span> {itemLabel}
      </p>
      <div className="flex items-center gap-2">
        <Button
          type="button"
          variant="outline"
          size="sm"
          className="h-10 rounded-xl"
          disabled={safePage <= 1}
          onClick={() => onPageChange(safePage - 1)}
        >
          <ChevronLeft className="mr-1 h-4 w-4" />
          Sebelumnya
        </Button>
        <span className="min-w-20 text-center text-sm font-medium text-stone-700">
          {safePage} / {totalPages}
        </span>
        <Button
          type="button"
          variant="outline"
          size="sm"
          className="h-10 rounded-xl"
          disabled={safePage >= totalPages}
          onClick={() => onPageChange(safePage + 1)}
        >
          Berikutnya
          <ChevronRight className="ml-1 h-4 w-4" />
        </Button>
      </div>
    </div>
  );
};

export default AdminPagination;
